/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.navigation.controllers', [
  'acme.common.service.posConfig'
])

.controller('PosCreatePagesFormsNavigationController', ['$scope', '$timeout', '$filter', 'PosConfigService', function($scope, $timeout, $filter, PosConfigService) {

    $scope.posCreatePagesFormsNavigation = {
            
      model: {},
      list: [],

      title: '',
      subTitle: '',
      color: '',
      selected: '',
      modelPage: '',
      showIcon: false,
      reduceList: false,
      colorCodes: {
        textColor: '',
        backgroundColor: ''
      },

      spectrumConfig: {
        titleText: 'Tile color'
      },

      init: function() {
        this.list =  this.process(PosConfigService.pages.getModel());

        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);

        $scope.$watch('posCreatePagesFormsNavigation.selected', this.onSelected);

        $scope.$watchCollection('posCreatePagesFormsNavigation.colorCodes', this.onColorCodesUpdate);
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      hasSelected: function() {
        return (this.selected && typeof this.selected === 'object');
      },

      getTitle: function() {
        var r = 'Enter a title';
        if (this.selected && this.selected.pageHeader) {
          r = this.selected.pageHeader;
        }
        return r;
      },

      remove: function() {
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', this.model);
      },

      cancel: function() {
        $scope.$emit('PosCreatePagesFormsController::Cancel', this.model);
      },

      resetSelected: function() {
        var found, self = $scope.posCreatePagesFormsNavigation;
        $timeout(function() {
          //reset page selected if no page is chosen
          if (!self.hasSelected()) {
            found = PosConfigService.pages.findPage(self.model.config.pageId);

            if (found) {
              self.selected = found.page;
            }
          }
          this.reduceList = false;
        },0);
      },

      filterList: function(viewValue, reduce) {
        var r;

        if (viewValue && viewValue.length > 0 && (reduce || this.reduceList)) {
          r = $filter('filter')(this.list, { pageHeader: viewValue });
        }else{
          r =  this.list;
        }

        return r;
      },

      done: function () {
        this.model.name = '';
        if (this.title) {
          this.model.name = this.title;
        } else if (this.selected && this.selected.pageHeader) {
          this.model.name = this.selected.pageHeader;
        }

        if (this.hasSelected()) {
          this.model.config.pageId = this.selected.pageId;
          this.model.pageNumber = this.selected.pageNumber;
          this.model.id = null;
          delete this.model.id;
        }

        this.model.icon = (this.showIcon) ? 'navigation' : 'none';

        this.model.subTitle = this.subTitle;
        this.model.color = PosConfigService.tiles.toColor(this.color);
        if (!this.model.color.a) {
          this.model.color.a = 1;
        }
        this.model.type = 'navigation';

        PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), this.model);
        $scope.$emit('PosCreatePagesFormsController::UpdateTile');
      },

      process: function(pages) {
        var i, ii,
            r = [],
            page = PosConfigService.pages.getSelectedPage().page;

        for (i=0,ii=pages.length;i<ii;i++) {
          if (pages[i].pageId !== page.pageId) {
            if (!pages[i].pageHeader.match(/\s$/)) {
              pages[i].pageHeader += " ";
            }
            r.push(pages[i]);
          }
        }

        return r;
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onSelected: function(n, o) {
        var self = $scope.posCreatePagesFormsNavigation;

        if (self.hasSelected() && self.model.config.pageId == self.selected.pageId) {
          if (self.model.name && self.model.name.length) {
            self.title = (self.model.name !== self.selected.pageHeader) ? self.model.name : '';
          }else{
            self.title = '';
          }
          self.subTitle = self.model.subTitle;
        } else {
          self.title = '';
          self.subTitle = '';
        }
      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {
        var found,
            self = $scope.posCreatePagesFormsNavigation;

        if (data.config.type === 'navigation') {
          self.selected = '';

          self.model = data;
          // Force watcher change event by resetting color to black
          self.spectrumConfig.color = '#000000';
          self.color = PosConfigService.tiles.toHex(PosConfigService.tiles.colorToRgb(self.model));
          // next tick
          $timeout(function() {
            self.spectrumConfig.color = self.color;
          }, 0);

          self.showIcon = (self.model.icon && self.model.icon !== 'none');

          // next tick
          $timeout(function() {
            self.list = self.process(PosConfigService.pages.getModel());

            found = PosConfigService.pages.findPage(data.config.pageId);

            if (found) {
              self.selected = found.page;
              self.title = (self.model.name !== found.page.pageHeader) ? self.model.name : '';
            }
          }, 0);
        }
      },

      onColorCodesUpdate: function(n, o) {
        if (n && n !== o) {
          $scope.posCreatePagesFormsNavigation.color = n.backgroundColor;
        }
      }

    };

    $scope.posCreatePagesFormsNavigation.init();

}]);